import { ObjectType } from '../../../tokens-and-interfaces';

export const ActivityDirection = {
  Outbound: 'Outbound',
  Inbound: 'Inbound',
  Forwarded: 'Forwarded',
};

export const CallStatus = {
  Connected: 'Connected',
  Busy: 'Busy',
  Rejected: 'Rejected',
  Voicemail: 'Left voicemail',
  NoAnswer: 'No answer',
  NotInService: 'Not in service',
  WrongNumber: 'Wrong number',
};

export const ActivityOutcome = {
  BusinessReview: 'Business review',
  Demo: 'Demo scheduled',
  DemoCompleted: 'Demo completed',
  Discovery: 'Discovery',
  Interested: 'Interested',
  NoInterest: 'No interest',
  Presentation: 'Presentation',
  QualityConnect: 'Quality connect',
  Rescheduling: 'Rescheduling',
  Referred: 'Referred to other representatives',
  Timeline: 'Timeline 6-12 months',
};

export const MeetingDuration = {
  FiveMin: 300000,
  FifteenMin: 900000,
  ThirtyMin: 1800000,
  OneHour: 3600000,
  OneHourThirtyMin: 5400000,
  TwoHoursPlus: 7200000,
};

export const MeetingStatus = {
  Scheduled: 'Scheduled',
  Rescheduled: 'Rescheduled',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  NoShow: 'No show',
  ReminderSent: 'Reminder sent',
  ReminderDelivered: 'Reminder delivered',
  ReminderFailed: 'Reminder failed',
  ConfirmationSent: 'Confirmation sent',
  ConfirmationDelivered: 'Confirmation delivered',
  ConfirmationFailed: 'Confirmation failed',
};

export interface CrmObjectIdentifier {
  crmObjectId: string;
  objectType: ObjectType;
}

export const ActivityTypes = {
  Email: 'Email',
  Note: 'Note',
  Meeting: 'Meeting',
  Call: 'Call',
  RecordChange: 'RecordChange',
  Task: 'Task',
  Communication: 'Communication',
  OpportunityChange: 'OpportunityChange',
  Notification: 'Notification',
};

export const ActivityIcons = {
  [ActivityTypes.Note]: 'notes',
  [ActivityTypes.Email]: 'email',
  [ActivityTypes.Call]: 'call',
  [ActivityTypes.Meeting]: 'calendar_today',
  [ActivityTypes.Task]: 'assignment_turned_in',
  [ActivityTypes.Communication]: 'message',
  [ActivityTypes.OpportunityChange]: 'monetization_on',
  [ActivityTypes.Notification]: 'notifications',
};

export const ActivityRecordChangeIcons: { [key: string]: string } = {
  Company: 'business',
  Contact: 'person',
  Opportunity: ActivityIcons[ActivityTypes.OpportunityChange],
};

export const ActivitySource = {
  Form: 'Form',
  List: 'List',
};

export const ActivityNoteIcons = {
  [ActivitySource.Form]: 'text_snippet',
  [ActivitySource.List]: 'list',
  default: 'sync_alt',
};

export const EmailIcons = {
  campaign: 'campaign',
  default: ActivityIcons[ActivityTypes.Email],
};

export const CommunicationType = {
  PhoneCall: 'phone_call',
  CampaignSMS: 'Campaign SMS',
  SMS: 'SMS',
  Inbox: 'Inbox',
};

export const CommunicationIcons = {
  [CommunicationType.PhoneCall]: 'call',
  [CommunicationType.CampaignSMS]: 'campaign',
  [CommunicationType.SMS]: 'forum',
  [CommunicationType.Inbox]: 'forum',
  default: ActivityIcons[ActivityTypes.Communication],
};
